<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="data">7. Data and Measurement Locations</h2>
        <p>
          The <a href="https://www.geomountains.org/resources/resources-surveys/inventory-of-in-situ-observational-infrastructure">GEO Mountains Inventory of In Situ Observational Infrastructure</a> lists a total of <strong>{{ factsheet.data.mountain_data.geomountains.stations_total }}</strong> mountain observatories in this mountain range. The average density of stations is <strong>{{ (factsheet.data.mountain_data.geomountains.stations_density * 1000).toFixed(1) }} locations per 1000km²</strong>.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col col-8">
        <ImageMap 
          title="In-situ measurement stations" 
          v-bind:images="[{title:'test',source:'/mountain_data/Data.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: GEO-MOUNTAINS">
        </ImageMap>
      </div>
      <div class="col col-4">
        <table class="table table-sm">
          <caption>Number of Stations By Country</caption>
          <tr>
            <th>Country</th><th>Number of Stations</th>
          </tr>
          <tr v-for="item in factsheet.data.mountain_data.geomountains.stations_by_country">
            <td>{{ item.name }}</td>
            <td>{{ item.count }}</td>
          </tr>

        </table>

      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import ImageMap from '@/components/factsheet/maps/ImageMap.vue'

    import _ from 'lodash';

    export default {
        name: 'Data',
        components: { ImageMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        filters: {
          percent: function (value) {
            return value.toFixed(1)+'%'
          }
        },
        methods: {
          urlFor(asset) {
            return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
          },
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>

<style scoped>

caption {
  caption-side: top;
  font-weight:bold;
  font-size:1em;
  padding:5px;
  color:rgb(33, 37, 41);
  padding-left:0px;
}
table {
   font-size:0.75em;
}
table th, table td {
  padding-left:0px;
}

</style>